import React from "react";
import "./ChallengeStatsCard.css";

const ChallengeStatsCard = ({
  rank = 0,
  coins = 0,
  score = 0,
  isLoading = false,
  onCoinsClick,
  onLeaderboardClick,
}) => {
  const stats = [
    {
      label: "Rank",
      value: rank,
      icon: "bi-trophy-fill",
      onClick: onLeaderboardClick,
    },
    {
      label: "Coins",
      value: coins,
      icon: "bi-coin",
      onClick: onCoinsClick,
    },
    {
      label: "Score",
      value: score,
      icon: "bi-award-fill",
      onClick: onLeaderboardClick,
    },
  ];

  return (
    <div className="gbs-stats-wrapper" aria-busy={isLoading}>
      {stats.map((stat) => (
        <button
          key={stat.label}
          type="button"
          className="gbs-stat-card"
          onClick={stat.onClick}
          disabled={!stat.onClick}
        >
          <div className="gbs-stat-icon-wrapper">
            <div className="gbs-stat-icon">
              <i className={`bi ${stat.icon}`}></i>
            </div>
          </div>

          <div className="gbs-stat-info">
            <span className="gbs-stat-label">{stat.label}</span>
            <strong className="gbs-stat-value">{isLoading ? "..." : stat.value}</strong>
          </div>
        </button>
      ))}
    </div>
  );
};

export default ChallengeStatsCard;
